/**
 * Model class for a Bulk Tank. Each bulk tank can contain zero or more VoyageBulk.
 */


var VRC = VRC || {};

VRC.BulkTank = (function(bulkTank){
  var DEFAULT_COLOUR = "#ff9933",

  _content,

  _capacity,
  _id,
  _isRob,
  _tankName,
  _radius,
  _tankShape,
  _tankType,
  _valueUnit,
  _positionX,
  _positionY,
  _consumableSeqNo,
  _contentDesc,
  _availableForDelivery,
  _bulkTankPumpSystemName,
  _colorCode;

    var init = function(bulkTank){
     _content = [];
     parse(bulkTank)

  };

  var isConsumable = function(){

    return !(getConsumableSeqNo() === undefined || getConsumableSeqNo() === null);
  };

  var isLng = function(){
      return getConsumableSeqNo() === G_CONSUMABLE_SEQ.LNG;
  };

  var isFuel = function(){
    return getConsumableSeqNo() === G_CONSUMABLE_SEQ.FUEL;
  };

  var isFuelConsumable = function(){
    return isFuel() ||  isLng();
  };


  var getCapacity = function () {
    return _capacity;
  };

  var setCapacity = function (capacity) {
    _capacity = capacity;
  };

  var getBulkTankId = function () {
    return _id;
  };

  var setBulkTankId = function (id) {
    _id = id;
  };

  var getName = function () {
    return _tankName;
  };

  var setName = function (name) {
    _tankName = name;
  };

  var getRadius = function () {
    return _radius;
  };

  var setRadius = function (radius) {
    _radius = radius;
  };

  var getShape = function () {
    return _tankShape;
  };

  var setIsRob = function(isRob){
     _isRob = isRob;
  };


  var setShape = function (shape) {
    _tankShape = shape;
  };

  var getType = function () {
    return _tankType;
  };

  var setType = function (type) {
    _tankType = type;
  };

  var getValueUnit = function () {
    return _valueUnit;
  };

  var setValueUnit = function (valueUnit) {
    _valueUnit = valueUnit;
  };

  var getXPos = function () {
    return _positionX;
  };

  var setXPos = function (xPos) {
    _positionX = xPos;
  };
  var getYPos = function () {
    return _positionY;
  };

  var setYPos = function (yPos) {
    _positionY = yPos;
  };

  var getConsumableSeqNo = function () {
    return _consumableSeqNo;
  };

  var setConsumableSeqNo = function (consumableSeqNo) {
    _consumableSeqNo = consumableSeqNo;
  };

  var getContentDesc = function () {
    return _contentDesc;
  };

  var setContentDesc = function (contentDesc) {
    _contentDesc = contentDesc;
  };

  var getAvailableForDelivery = function() {
      return _availableForDelivery;
  };

  var setAvailableForDelivery = function (availableForDelivery) {
      _availableForDelivery = availableForDelivery;
  };

  var getBulkTankPumpSystemName = function() {
    return _bulkTankPumpSystemName;
  };

  var setBulkTankPumpSystemName = function(bulkTankPumpSystemName) {
      _bulkTankPumpSystemName = bulkTankPumpSystemName;
  };

  var getPumpSystemColorCode = function() {
    return _colorCode;
  };

  var setPumpSystemColorCode = function(colorCode) {
      _colorCode = colorCode;
  };

  var getLatestContent = function (allContent) {
    allContent = allContent || _content;


    if(allContent.length === 0){
      return null;
    }
    return _.max(allContent,
      function (content) {
            return moment(content.getDate(), g_timeStampFormat).valueOf()
      });
  };


  var getFirstContent = function (content, filter) {

    var filter = filter || function(voyageBulk){
       return true;
    };

    content = content || _content;
    if(content.length === 0){
      return null;
    }

    var firstContent = _.chain(content)
      .filter(filter)
      .min(function (voyageBulk) {

        return moment(voyageBulk.getDate(), g_timeStampFormat).valueOf()
      }).
      value();


    return firstContent !== Infinity ? firstContent : null;

  };

  var getFirstContentIgnoreStartRob = function (content) {
    var filter = function(voyageBulk){
      return !voyageBulk.isStartRobAction();
    };
    return getFirstContent(content, filter);

  };



  var getLatestContentByContainerId = function(containerId){

    var filteredContent = [];
    if(!containerId || containerId === 'undefined'){
      filteredContent = _.filter(_content, function(voyageBulk){
        return voyageBulk.getContainerId() === undefined;
      });

    }
    else{
      filteredContent = _.filter(_content, function(voyageBulk){
        return voyageBulk.getContainerId() == containerId;
      });
    }
    return getLatestContent(filteredContent);
   };

  var getContentOnDate = function(date){
     return _.filter(_content, function(voyagebulk){
       return moment(voyagebulk.getDate(), g_timeStampFormat).isSame(date);
     })
  };

 var getSeqNoOnDate = function(date){
    var onDate = getContentOnDate(date);

    if(onDate.length === 0){
      return 1;
    }
    return _.max(onDate, function(voyageBulk){
      return voyageBulk.getSeqNo();
    }) + 1;
  };

  var addContent = function(voyageBulk){

    _content.unshift(voyageBulk);
    recalcRob();
  };

  var getContentById = function(voyageBulkId){
    return _.find(_content, function(voyageBulk) {
      return voyageBulk.getVoyageBulkId() == voyageBulkId;
    });
  };

  var getQtyRob = function(){
    var filter = function(cargoItem){
      return cargoItem.getQtyRob() !== undefined;
    };
    var lastAction = getLast(filter);
    return lastAction ? lastAction.getQtyRob() : 0;
  };

  var removeContent = function(voyageBulk){
    if(typeof voyageBulk === 'object'){
      voyageBulk = voyageBulk.getVoyageBulkId();
    }

    _content = _.without(_content, getContentById(voyageBulk));
    recalcRob();
  };

  var clearTank = function(){
    _content = [];
    recalcRob()
  };

  var getTankColour = function(){
    var colour = DEFAULT_COLOUR;
    var lastAction = getLastActionRigOrClean();
    if (lastAction) {
        colour = lastAction.getTankColour();
    }
    return colour;
  };

  var parse = function(bulkTank){
    _content = [];
    setBulkTankId(bulkTank.bulkTankId);
    setName(bulkTank.tankName);
    setType(bulkTank.tankType);
    setShape(bulkTank.tankShape);
    setCapacity(bulkTank.tankCapacity);
    setRadius(bulkTank.tankRadius);
    setXPos(bulkTank.positionX);
    setYPos(bulkTank.positionY);
    setContentDesc(bulkTank.contentDesc);
    setConsumableSeqNo(bulkTank.consumableSeqNo);
    setValueUnit(bulkTank.valueUnit);
    setAvailableForDelivery(bulkTank.availableForDelivery);
    setBulkTankPumpSystemName(bulkTank.bulkTankPumpSystemName);
    setPumpSystemColorCode(bulkTank.pumpSystemColorCode);

    _.each(bulkTank.content, function(voyageBulk){
        _content.push(VRC.VoyageBulk(voyageBulk));
    });

  };

  var toJson = function () {
    var json = {
      "bulkTankId": getBulkTankId(),
      "tankName": getName(),
      "tankType": getType(),
      "tankShape": getShape(),
      "tankCapacity": getCapacity(),
      "tankRadius": getRadius(),
      "positionX": getXPos(),
      "positionY": getYPos(),
      "contentDesc": getContentDesc(),
      "consumableSeqNo": getConsumableSeqNo(),
      "valueUnit": getValueUnit(),
      "tankColour" : getTankColour(),
      "isSpecialTank" : isSpecialTank(),
      "availableForDelivery" : getAvailableForDelivery(),
      "bulkTankPumpSystemName" :  getBulkTankPumpSystemName(),
      "pumpSystemColorCode" : getPumpSystemColorCode()
    };

    json.content = [];

    $.each(getContent(), function(ii, voyageBulk){
      json.content.push(voyageBulk.toJson());
    });

    return json;
  };

  var getLastTankClean = function(){
    var filter = function(cargoItem){
      return cargoItem.isTankClean();
    };
    return getLast(filter);
  };


  var getLastAction = function(){
    var filter = function(cargoItem){
      return cargoItem.isCalcAction();
    };

    var last = getLast(filter);

    if(last === -Infinity){
      last = undefined;
    }

    return last;
  };

    var getLastActionRigOrClean = function(){

        var filter = function(cargoItem){
            return cargoItem.isCalcAction();
        };

        var action;
        var calcActions =  _.filter(_content, filter);
        var magicNumber = 10000000000; //Hack, we want to sort the following Date, then all server ids, then the timestamp of the ad-hoc bulk.

        if(!_.isEmpty(calcActions)){

            action = _.chain(calcActions)
                .sortBy(function(voyageBulk) {
                    var calcId =  voyageBulk.getCalcId() < 0 ?  magicNumber + voyageBulk.getCalcId()  :  voyageBulk.getCalcId();

                    return moment(voyageBulk.getDate(), g_timeStampFormat).valueOf() + '_' + calcId;
                })
                .reverse()
                .find(function (action) {
                    var remarks = action.getRemarks();
                    return action.getAction() === g_actions.tankClean 
                           // #54169 added a check for "Cleaned" in the remarks, needed in new voyages as the tank cleaning is not carried over.
                           || (action.getAction() === g_actions.start_rob  && remarks && remarks.indexOf('Cleaned ') > -1)
                           || isRig(action.getOriginId()) 
                           || isRig(action.getDestinationId());
                }).value();
        }
        return action;
    };

  function isRig(portId) {
      var port = VRC.MasterDataService.getPort(portId);
      return VRC.MasterDataService.isRig(port);
  }

  //Todo, this is really ugly..
  var getLast = function(filter){
    var lastAction;
    var calcActions =  _.filter(_content, filter);
    var magicNumber = 10000000000; //Hack, we want to sort the following Date, then all server ids, then the timestamp of the ad-hoc bulk.
    if(!_.isEmpty(calcActions)){
      lastAction = _.reduce(calcActions ,function(voyageBulk1, voyageBulk2){
      var calcId =  voyageBulk1.getCalcId() < 0 ?  magicNumber + voyageBulk1.getCalcId()  :  voyageBulk1.getCalcId();
      var calcId2 =  voyageBulk2.getCalcId() < 0 ?   magicNumber + voyageBulk2.getCalcId() :  voyageBulk2.getCalcId();
        var comparableId =  moment(voyageBulk1.getDate(), g_timeStampFormat).valueOf() + '_' + calcId;
        var str2 =  moment(voyageBulk2.getDate(), g_timeStampFormat).valueOf() + '_' + calcId2;
        return comparableId>str2?voyageBulk1:voyageBulk2;
      });
    }

    return lastAction;
  };

  var hasStartRob = function(){
    return _.some(_content, function(voyageBulk){
      return voyageBulk.isStartRobAction();
    });
  };



  var getLoadActions = function(){

    return _.filter(_content, function(content){
       return content.isCalcAction();
    })
  };

  var getRobActions = function(){
    return _.filter(_content, function(content){
        return content.isRob();
    })
  };

   var isSpecialTank = function(){
     return getBulkTankId() < 0;
   };




  var fillTank = function(contentArray){
    _content = _.map(contentArray, function(contentJson){ return VRC.VoyageBulk(contentJson) });

    recalcRob();
  };


    var _bulkTypeSeqNoMapping = {
      1 : 230, //Fuel
      2 : 244, // LNG
      3 : 237, //POTWATER
      4 : 231, //DRILLWATER
      5 : 223, //Lubeoil
      6 : 222 //UREA
    };



  var getOffloadableContent = function(){
   var lastTankClean;
   var lastTankCleanVoyageBulk = getLastTankClean();
   if(lastTankCleanVoyageBulk){
     lastTankClean = moment(lastTankCleanVoyageBulk.getDate(), g_timeStampFormat);
   }

   var lastAction = getLastAction();

   var lastRegisteredRob =  lastAction ? lastAction.getQtyRob() : 0;

   var filteredAndGrouped =
    _.chain(_content)
          .filter(function(cargoItem){

            if(!lastTankClean){
              return true;
            }
            return moment(cargoItem.getDate(), g_timeStampFormat).isAfter(lastTankClean);
          })
           .sortBy(function(content){

              return  moment(content.getDate(), g_timeStampFormat).toISOString();
           })
          .groupBy(function(content){
              return content.getContainerId()
            })
          .value();


   var sum = _.map(filteredAndGrouped, function(voyageBulkList, containerId) {
     var bulkTypeId = voyageBulkList[0].getBulkTypeId();
     if(isConsumable() && containerId === "undefined"){
       bulkTypeId = _bulkTypeSeqNoMapping[getConsumableSeqNo()];
     }
      return {
        containerId: containerId,
        bulkTankId : getBulkTankId(),
        qtyRob : lastRegisteredRob,
        displayName : voyageBulkList[0].getDestinationName(),
        valueUnit : voyageBulkList[0].getValueUnit(),
        itemDescription : voyageBulkList[0].getItemDescription(),
        bulkTypeId : bulkTypeId,
        valueQty : _(voyageBulkList).reduce(function (memo, voyageBulk) {
          if(voyageBulk.getAction() === 'rob'){
            return voyageBulk.getQtyRob();
          }
          else{
            return memo + voyageBulk.getCalcQty();
          }

        }, 0)
      }
    });
    sum = _.filter(sum, function(item){ return item.valueQty > 0 })

   return sum;
  };

  var recalcRob = function(){
    var sortedContent = getContent().reverse();

     _.reduce(sortedContent, function(memo, voyageBulm){
       var calced = voyageBulm.getCalcQty();
       calced = calced || 0;
       var sum = memo + calced;

       if(voyageBulm.isTankClean() || voyageBulm.isTankCleanStarted()){
          sum = 0;
        }
        else if(voyageBulm.isRob() || voyageBulm.isRobAdjustment()){
         sum = voyageBulm.getValueQty()
       }
        voyageBulm.setQtyRob(sum);
        return sum;
    }, 0);
  };

  var getContent = function () {
    return  _(_content).chain().sortBy(function (voyageBulk) {
      return voyageBulk.getCalcId();
    }).sortBy(function (voyageBulk) {

      return moment(voyageBulk.getDate(), g_timeStampFormat).valueOf();
    }).reverse().value();



  };

  var getStartDateTime = function () {
    var currentVoyage = VRC.CurrentVoyage.getCurrentVoyage();
    var dateTime = currentVoyage.getFromDateTime() || '';
    if (dateTime.trim() === '') { //There is no dateTime for current voyage
      var firstContent = getFirstContent();
      if (firstContent === null) { //There is no other events set to now
        dateTime = moment().format(g_timeStampFormat);
      } else { //Set one minute before the first registered event on this tank.
        dateTime = moment(firstContent.getDate(), g_timeStampFormat).subtract(1, 'minute').format(g_timeStampFormat);
      }
    }
    return dateTime;
  };

  var createStartRob = function(qty, bulkType){
    var dateTime = getStartDateTime();

    bulkType = bulkType || getType();

    var newRob = VRC.VoyageBulk({});
      newRob.setAction(g_actions.start_rob);
      newRob.setDate(dateTime);
      newRob.setQtyRob(qty || 0);
      newRob.setValueQty(qty || 0);

      addContent(newRob);
  };




  init(bulkTank);

  return {
    createStartRob : createStartRob,
    getContent : getContent,
    isConsumable : isConsumable,
    isFuelConsumable : isFuelConsumable,
    isFuel : isFuel,
    isLng : isLng,
    toJson : toJson,
    setBulkTankId : setBulkTankId,
    getBulkTankId : getBulkTankId,
    getName : getName,
    setName : setName,
    getRadius : getRadius,
    setRadius : setRadius,
    getShape : getShape,
    setShape : setShape,
    getType : getType,
    setType : setType,
    getValueUnit : getValueUnit,
    setValueUnit : setValueUnit,
    getXPos : getXPos,
    setXPos : setXPos,
    setYPos : setYPos,
    getYpos : getYPos,
    getConsumableSeqNo : getConsumableSeqNo,
    setConsumableSeqNo : setConsumableSeqNo,
    parse : parse,
    getLatestContent : getLatestContent,
    getLatestContentByContainerId : getLatestContentByContainerId,
    addContent : addContent,
    removeContent : removeContent,
    clearTank : clearTank,
    fillTank : fillTank,
    getOffloadableContent : getOffloadableContent,
    getLastTankClean :getLastTankClean,
    getRobActions : getRobActions,
    getLastAction : getLastAction,
    getContentById : getContentById,
    getTankColour: getTankColour,
    getQtyRob : getQtyRob,
    isSpecialTank : isSpecialTank,
    recalcRob : recalcRob,
    hasStartRob : hasStartRob,
    getFirstContent : getFirstContent,
    getFirstContentIgnoreStartRob : getFirstContentIgnoreStartRob,
    getAvailableForDelivery : getAvailableForDelivery,
    setAvailableForDelivery : setAvailableForDelivery,
  }
});
